<template>
    <fragment>
        <LoveMapIndex/>
        <LoveMapAdmin/>
        <LoveMapSettings/>
        <LoveMapWooCommerce/>
        <TxProductStats/>
    </fragment>
</template>

<script>
    import LoveMapWooCommerce from "./__partials__/LoveMapWooCommerce";
    import LoveMapSettings from "./__partials__/LoveMapSettings";
    import LoveMapIndex from "./__partials__/LoveMapIndex";
    import LoveMapAdmin from "./__partials__/LoveMapAdmin";

    let layout = lovemap.vue_env;

    export default {
        name: "index",
        layout: layout,
        components: {
            LoveMapAdmin,
            LoveMapIndex,
            LoveMapSettings,
            LoveMapWooCommerce
        }
    }
</script>

<style scoped>

</style>